<template>
    <div class="context common_table_view">
        <div class="header">
            <div class="search">
               <div class="search_item">
                   <div class="title">
                       名字:
                   </div>
                   <div class="input-box">
                       <el-input v-model="searchForm.input"
                                 placeholder="请输入"
                                 @change="getTableData()"
                                 size="small"
                                 class="width_300"
                                 clearable>
                           <el-button slot="append"
                                      @click="getTableData()"
                                      icon="el-icon-search"></el-button>
                       </el-input>
                   </div>
               </div>
            </div>
            <div class="btn-box">
                <el-button class="new_btn"
                           @click="openNew"
                           type="primary"
                           size="small">新建问卷
                </el-button>
            </div>
        </div>
        <div class="table">
            <el-table :data="tableData"
                      stripe
                      width="100%"
                      height="100%">
                <el-table-column v-for="(item, index) in columnData"
                                 :prop="item.prop"
                                 :label="item.label"
                                 :width="item.width"
                                 :formatter="item.formatter"
                                 :fixed="item.fixed"
                                 show-overflow-tooltip
                                 :key="index"></el-table-column>
                <!---->
                <el-table-column label="积分">
                    <template slot-scope="scope">
                        <div>
                            <div v-if="edit_row && edit_row_index === scope.$index">
                                <el-input-number v-model="edit_row.score"
                                                 class="width_100"
                                                 controls-position="right"
                                                 size="mini"
                                                 :max="100"
                                                 :min="1"></el-input-number>
                                <el-button type="primary"
                                          @click="enter_edit"
                                           style="margin-left: 5px"
                                          size="mini">确定</el-button>
                            </div>
                            <div @dblclick="edit_jifen(scope)"
                                 v-else
                                 class="jifen_box">
                                {{scope.row.score || '默认'}}
                            </div>
                        </div>

                    </template>
                </el-table-column>
                <el-table-column label="预览" width="60">
                    <template slot-scope="scope">
                        <el-popover
                                placement="left"
                                width="200"
                                v-if="scope.row.wxmini_qrcode_url"
                                trigger="click">
                            <div class="qrcode" style="height: 200px">
                                <el-image :src="scope.row.wxmini_qrcode_url"
                                    style="width: 200px;height: 200px"
                                ></el-image>
                            </div>
                            <span slot="reference"
                                  style="cursor: pointer"
                                  class="iconfont icon-erweima"></span>
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <span class="table_btn"
                              v-if="scope.row.status != 2"
                              @click="editRow(scope.row,'edit')">
                            <i class="el-icon-edit"></i>
                            编辑
                        </span>
                        <span class="table_btn"
                              v-if="scope.row.status == 2"
                              @click="editRow(scope.row,'look')">
                            <i class="el-icon-edit"></i>
                            查看
                        </span>
                        <span class="table_btn"
                              v-if="scope.row.status != 2"
                              @click="openUpload(scope.row, 2)">
                            <i class="el-icon-upload2"></i>
                            发布
                        </span>
                        <span class="table_del_btn"
                              v-if="scope.row.status == 2"
                              @click="changeStatus(scope.row, 3)">
                            <i class="el-icon-close"></i>
                            停止
                        </span>
                        <span class="table_btn"
                              v-if="scope.row.status == 2 && (!scope.row.survey_type || scope.row.survey_type != 2)"
                              @click="add_del_doctor(scope.row, 2)">
                            <i class="el-icon-circle-plus-outline"></i>
                            放入医生端
                        </span>
                        <span class="table_del_btn"
                              v-if="scope.row.status == 2 && scope.row.survey_type == 2"
                              @click="add_del_doctor(scope.row, 1)">
                            <i class="el-icon-delete"></i>
                            移出医生端
                        </span>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div class="bottom_page">
            <page-view @getTableList="handleCurrentChange"
                       :currentPage="currentPage"
                       :pageSize="pageSize"
                       :total="total"></page-view>
        </div>

        <el-dialog
                title="截止时间"
                :visible.sync="dialogVisible"
                width="450px"
                :modal="false"
                :close-on-click-modal="false"
                :close-on-press-escape="false"
                :show-close="false">
            <div>
                <el-form :model="dialog_form" label-width="100px">
                    <el-form-item label="截止时间：">
                        <el-date-picker
                                v-model="dialog_form.end_time"
                                type="datetime"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                placeholder="选择日期时间">
                        </el-date-picker>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="submit_time">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {mapMutations, mapState} from "vuex";
    import {clone} from "@/global/utils";
    import vueQr from 'vue-qr'

    export default {
        name: "tableView",
        components: {
            vueQr
        },
        data() {
            return {
                imageUrl: '', // 无用 vueQr必须
                searchForm: {
                    input: '',
                },
                tableData: [],
                columnData: [
                    {label: '问卷标题', prop: 'title'},
                    {label: '开始描述', prop: 'start_description'},
                    {label: '结束描述', prop: 'end_description'},
                    {label: '创建时间', prop: 'create_time'},
                ],

                edit_row: null,
                edit_row_index: -1,

                total: 0,
                currentPage: 1,
                pageSize: 50,

                dialogVisible: false,
                upload_id: null,
                dialog_form: {
                    end_time: ''
                }
            }
        },
        computed: {

        },
        mounted() {
            this.getTableData();
        },
        methods: {
            ...mapMutations("questionData", {
                setAddData: 'setAddData'
            }),
            getVueQrUrl(row) {
                return ''
            },
            openNew() {
                let data = {
                    title: '新建问卷',
                    survey_id: null
                };
                this.setAddData(data);
                this.$emit("changeTopTab", 'addView')
            },
            editRow(row, type) {

                this.httpGet(`/survey/detail/${row.survey_id}`).then(res => {
                    let data = {
                        title: type==='edit'?'编辑问卷':type==='look'?'查看问卷':'',
                        survey_id: row.survey_id
                    };
                    this.setAddData(data);
                    this.$emit("changeTopTab", 'addView')
                });

            },

            delRow(row) {
                // 当前页全部删除后进入上一页
                return;
                let listLength = this.tableData.length;
                let nowPage = this.currentPage;
                if (listLength === 1) {
                    if (this.currentPage > 1) {
                        nowPage = this.currentPage - 1
                    } else {
                        nowPage = 1
                    }
                }

                this.$confirm('是否删除该问卷?').then(res => {
                    let params = {

                    };
                    this.httpDel(`/survey/question/delete`, params).then(res => {
                        if (res.code === 0) {
                            this.$message.success('已成功删除！');
                            this.getTableData(nowPage);
                        }
                    })
                })
            },
            changeStatus(row, val) {
                let params = {
                    survey_id: row.survey_id,
                    status: val
                };
                let msg = val === 2?'发布问卷成功':val===3?'停止问卷成功':'';
                this.httpPost('/survey/update_status', params).then(res => {
                    this.$message.success(msg);
                    this.getTableData(this.currentPage)
                })
            },
            add_del_doctor(row, val) {
                let params = {
                    status: val
                };
                let msg = val === 2?'放入医生端成功':val===3?'移出医生端成功':'';
                this.httpGet(`/survey/change_survey_type/${row.survey_id}`, params).then(res => {
                    this.$message.success(msg);
                    this.getTableData(this.currentPage)
                })
            },

            edit_jifen(scope) {
                if(this.edit_row) {
                    this.$message.warning('有正在修改的问卷，请完成');
                    return
                }
                this.edit_row = clone(scope.row);
                this.edit_row_index = scope.$index;
            },
            enter_edit() {
                let params = {
                    score: this.edit_row.score
                };
                this.httpPost(`/survey/${this.edit_row.survey_id}`, params).then(res => {
                    this.edit_row = null;
                    this.edit_row_index = -1;
                    this.getTableData(this.currentPage)
                })
            },

            openUpload(row) {
                this.upload_id = row.survey_id;
                this.dialog_form = {end_time: ''};
                this.dialogVisible = true;
            },
            submit_time() {
                let params = {
                    survey_id: this.upload_id,
                    status: 2,
                    end_time: this.dialog_form.end_time
                };
                this.httpPost('/survey/update_status', params).then(res => {
                    this.$message.success('发布问卷成功');
                    this.getTableData(this.currentPage);
                    this.dialogVisible = false
                })
            },

            handleCurrentChange(val) {
                this.getTableData(val)
            },
            getTableData(v = 1) {
                console.log('get_data');
                this.edit_row = null;

                let params = {
                    name: this.searchForm.input,
                    page: v,
                    page_size: this.pageSize
                };
                this.httpGet('/survey/list', params).then(res => {
                    this.tableData = res.data.data_list;
                    this.total = res.data.total;

                    this.$nextTick(() => {
                        this.currentPage = v
                    })
                });
            },
        }
    }
</script>

<style scoped lang="scss">
    .context {
        width: 100%;
        height: 100%;

        .jifen_box {
            cursor: pointer;
            width: 100%;
            user-select: none;
        }
    }
</style>